import React from "react";
import FadeInSection from "../../components/FadeInSection";
import footballDevelopment from "../../../images/football-development.jpg";
import RevenueChartImg from "../../../images/svgs/revenue-chart.svg";
import RegisteredImg from "../../../images/svgs/registered.svg";

const WhatWeDo = () => {
    return(
        <FadeInSection>
            <section className="row gap-2 mb-3">
                <div className="container">
                    <div className="col-12-xs col-6-md">
                        <div className="card">
                          <img src={footballDevelopment} alt="sport development" />
                          <img src={RevenueChartImg} alt="sport revenue" className="revenue-chart-img"/>
                          <img src={RegisteredImg} alt="sport revenue" className="registered-img"/>
                        </div>
                    </div>
                    <div className="col-12-xs col-6-md">
                        <div className="card">
                            <h3>Provide A Great Experience for Your Members</h3>
                            <p>Connect your players, coaches, staff, parents, and family members in one centralized app. <strong>Grassroots360</strong> keeps members happy with software that's easy to use and powerful to work with.</p>
                            <br></br>
                            <ul>
                                <li><span className="material-symbols-outlined">task_alt</span> Easily connect with all your members</li>
                                <li><span className="material-symbols-outlined">task_alt</span> Easily connect with all your players</li>
                                <li><span className="material-symbols-outlined">task_alt</span> Manage your club's finances</li>
                                <li><span className="material-symbols-outlined">task_alt</span> Manage your teams schedules</li>
                                <li><span className="material-symbols-outlined">task_alt</span> Make informed decisions to grow club revenues</li>
                                <li><span className="material-symbols-outlined">task_alt</span> Unlock the power of your club via club reports!</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            </FadeInSection> 
    )
}

export default WhatWeDo;